module.exports = __webpack_public_path__ + "static/media/instagram.013acd83.svg";